import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { JwtService } from '../jwt/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentLiberationService {
  apiUser: string = "";

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ) { 
    this.apiUser = environment.apiUser;
  }

  getAllPaymentRelease(): Observable<{contractId: number, active: boolean}[]> {
    return this.http.get<{contractId: number, active: boolean}[]>(`${this.apiUser}/settings/release/payments`);
  }

  updatePaymentRelease(data: any, otpToken: string) {
    const jwt = this.jwtService.signRequest("operacion", { datos: data }, otpToken)
    return this.http.post(`${this.apiUser}/settings/update/release/payments`, { jwt })
  }
}
